import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate, Navigate } from 'react-router-dom';
import '../styling/createquiz.css';

export default function Createquiz() {
    const inputref = useRef();
    const [ans, setans] = useState();
    const navigate = useNavigate();
    const [count, setcount] = useState(0);
    const [question1, setquestion1] = useState(`${localStorage.getItem('login_user_name').toUpperCase()} was very talented in?`);
    const [option1, setoption1] = useState({ opt0: "Stealing heart", opt1: "Flirting girls/boys", opt2: "Acting smart", opt3: "Making judgement" });
    const [question2, setquestion2] = useState(`The theft that was done by ${localStorage.getItem('login_user_name').toUpperCase()} that he got caught?`);
    const [option2, setoption2] = useState({ opt0: "Girls/Boys heart", opt1: "Exam paper", opt2: "Father money", opt3: "Friends food" });
    const [question3, setquestion3] = useState(`which superpower does ${localStorage.getItem('login_user_name').toUpperCase()} gets fascinated by the most?`);
    const [option3, setoption3] = useState({ opt0: "Hypnotism", opt1: "Mind reading", opt2: "Dr.Strange's spritual power", opt3: "Hulk strenth" });
    const [question4, setquestion4] = useState(`what crazy stuff does ${localStorage.getItem('login_user_name').toUpperCase()} mostly prefer?`);
    const [option4, setoption4] = useState({ opt0: "Cyber bullying (bullying friends with fake accounts)", opt1: "Gambling in exams", opt2: "Danceing/Singing alone", opt3: "Joking with friends" });
    const [question5, setquestion5] = useState(`when ${localStorage.getItem('login_user_name').toUpperCase()} got done with his heart. Which work make him to feel better?`);
    const [option5, setoption5] = useState({ opt0: "Sighting Girls/Boys", opt1: "Sharing his pain", opt2: "Listening songs", opt3: "Leave him alone" });
    const [question6, setquestion6] = useState(`what would ${localStorage.getItem('login_user_name').toUpperCase()} ask for, when he got a chance to ask the god?`);
    const [option6, setoption6] = useState({ opt0: "Parents happiness", opt1: "Richest in the world", opt2: "Virginity", opt3: "Boyfriend/Girlfriend" });
    const [question7, setquestion7] = useState(`Find ${localStorage.getItem('login_user_name').toUpperCase()}'s nick name that would reflect his charecter?`);
    const [option7, setoption7] = useState({ opt0: "Conjus", opt1: "Drinker/Smoker", opt2: "Gambler", opt3: "Thop" });
    const [question8, setquestion8] = useState(`who was ${localStorage.getItem('login_user_name').toUpperCase()}'s favorite cricketer?`);
    const [option8, setoption8] = useState({ opt0: "Virat Kohli", opt1: "AB de Villiers", opt2: "MS Dhoni", opt3: "Kane Williamson" });
    const [question9, setquestion9] = useState(`what is the best gift that ${localStorage.getItem('login_user_name').toUpperCase()} had recevied even?`);
    const [option9, setoption9] = useState({ opt0: "Parents/Friends", opt1: "Girlfriend/Boyfriend", opt2: "His knowledge", opt3: "Best Memories" });
    const questions = [
        {
            id: 1,
            question: question1,
            options: option1
        },
        {
            id: 2,
            question: question2,
            options: option2
        },
        {
            id: 3,
            question: question3,
            options: option3
        },
        {
            id: 4,
            question: question4,
            options: option4
        },
        {
            id: 5,
            question: question5,
            options: option5
        },
        {
            id: 6,
            question: question6,
            options: option6
        },
        {
            id: 7,
            question: question7,
            options: option7
        },
        {
            id: 8,
            question: question8,
            options: option8
        },
        {
            id: 9,
            question: question9,
            options: option9
        },
    ]
    const [sendques, setsendques] = useState([]);
    const ques = questions[count];
    const [loading, setloading] = useState(false);
    const btns = () => {
        setsendques([...sendques, { sendquestion: ques.question, sendoptions: ques.options, answer: ans }]);
        if (count < 8) {
            setcount(prev => prev + 1);
        }
        else {
            setcount(prev => prev);
        }
    }
    useEffect(() => {
        if (sendques.length === 9) {
            setloading(true);
            axios.post(`https://quiz-backend-mqz8.onrender.com/answer-quiz/${localStorage.getItem('login_user_id')}`, { data: sendques, name: localStorage.getItem('login_user_name') }).then(
                res => console.log("questions completed successfully")
            );
            localStorage.setItem('answer_completed', 'true');
            setloading(false);
            navigate('/result');
        }
    }, [sendques]);
    useEffect(() => {
        inputref.current.focus();
    }, []);
    if (loading) {
        return (
            <div className="loadanimation">
                Loading...
            </div>
        )
    }
    return (
        <>
            {
                localStorage.getItem('answer_completed') ? <Navigate to='/result' /> :
                    <div className='createquiz'>
                        <div className="queswhole">
                            <div className="queshead"><h2 className="questionhead">Question {ques.id} of 9</h2></div>
                            <div className="caution">You can edit questions and options as you like</div>
                            {count === 0 &&
                                <div className="ques">
                                    <div className="question"><textarea ref={inputref} name={ques.id} id="quest" value={ques.question} cols="30" rows="2" onChange={(e) => setquestion1(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption1({ ...option1, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption1({ ...option1, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption1({ ...option1, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption1({ ...option1, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 1 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion2(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption2({ ...option2, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption2({ ...option2, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption2({ ...option2, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption2({ ...option2, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 2 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion3(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption3({ ...option3, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption3({ ...option3, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption3({ ...option3, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption3({ ...option3, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 3 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion4(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption4({ ...option4, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption4({ ...option4, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption4({ ...option4, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption4({ ...option4, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 4 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion5(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption5({ ...option5, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption5({ ...option5, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption5({ ...option5, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption5({ ...option5, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 5 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion6(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption6({ ...option6, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption6({ ...option6, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption6({ ...option6, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption6({ ...option6, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 6 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion7(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption7({ ...option7, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption7({ ...option7, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption7({ ...option7, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption7({ ...option7, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 7 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion8(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption8({ ...option8, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption8({ ...option8, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption8({ ...option8, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption8({ ...option8, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            {count === 8 &&
                                <div className="ques">
                                    <div className="question"><textarea name={ques.id} id="quest" value={ques.question} cols="30" rows="3" onChange={(e) => setquestion9(e.target.value)} ></textarea></div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={0} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt0} onChange={(e) => setoption9({ ...option9, opt0: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={1} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt1} onChange={(e) => setoption9({ ...option9, opt1: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={2} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt2} onChange={(e) => setoption9({ ...option9, opt2: e.target.value })} />
                                    </div>
                                    <div className="options">
                                        <input type="radio" name='radio' id="radio" value={3} onChange={(e) => setans(e.target.value)} />
                                        <input type="text" className='text' value={ques.options.opt3} onChange={(e) => setoption9({ ...option9, opt3: e.target.value })} />
                                    </div>
                                </div>
                            }
                            <div className='btns'>
                                <button className='btn stbtn' onClick={btns}>Next</button>
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}
